<template>
  <div>
    <Head title="Create Booking" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link href="/bookings">Bookings</Link></li>
        <li class="breadcrumb-item active" aria-current="page">Create Booking</li>
      </ol>
    </nav>

    <BookingForm :form="form" :auth="auth" :customers="customers" :types="types" :operators="operators" :airports="airports" :products="products" />

    <form @submit.prevent="store">
      <div class="actions-toolbar d-flex justify-content-between">
        <loading-button :loading="form.processing" class="btn btn-primary" type="submit">Create Booking</loading-button>
      </div>
    </form>

  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import axios from 'axios'
import Editor from '@tinymce/tinymce-vue'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import BookingForm from './component/BookingForm'

export default {
  name: 'CreateBooking',
  components: {
    Head,
    Link,
    Editor,
    Icon,
    LoadingButton,
    BookingForm
  },
  layout: Layout,
  remember: 'form',
  props: {
    bookings: Object,
    customers: Object,
    flights: Object,
    airports: Object,
    operators: Object,
    types: Object,
    products: Object
  },
  data() {
    return {
      form: this.$inertia.form({
        status: this.$page.props.auth.user.agency.id == 1 ? 'draft' : 'request',
        customers_id: this.bookings && this.bookings.customers_id ? this.bookings.customers_id : null,
        itinerary: this.bookings && this.bookings.itinerary ? this.bookings.itinerary : {
          inbound: {
            airline: null,
            flight_number: null,
            date: null,
            time: null
          },
          outbound: {
            airline: null,
            flight_number: null,
            date: null,
            time: null
          },
        },
        show_itinerary: this.bookings && this.bookings.show_itinerary ? this.bookings.show_itinerary : true,
        journeys: this.bookings && this.bookings.journeys ? this.bookings.journeys : [],
        comment: this.bookings && this.bookings.comment ? this.bookings.comment : null,
        show_comment: this.bookings && this.bookings.show_comment ? this.bookings.show_comment : true,
        passengers: this.bookings && this.bookings.passengers ? this.bookings.passengers : [],
        order_lines: this.bookings && this.bookings.order_lines ? this.bookings.order_lines : [],
        intern_comment: this.bookings && this.bookings.intern_comment ? this.bookings.intern_comment : null,
        subtotal: this.bookings && this.bookings.subtotal ? this.bookings.subtotal : null,
        taxes: this.bookings && this.bookings.taxes ? this.bookings.taxes : null,
        final_total: this.bookings && this.bookings.final_total ? this.bookings.final_total : null,
        payment_url: this.bookings && this.bookings.payment_url ? this.bookings.payment_url : null,
      }),
    }
  },
  computed: {
    auth() {
      return this.$page.props.auth
    }
  },
  methods: {
    store() {
      this.form.post('/bookings')
    }
  },
}
</script>

<style lang="scss">

</style>
